import { NgModule  } from '@angular/core';

import { BookingRequestActionsComponent } from './booking.request.actions.component';
import { SharedModule }                   from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    BookingRequestActionsComponent
  ],
  entryComponents: [
    BookingRequestActionsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class BookingsModule {}